module.exports = __webpack_public_path__ + "static/media/translator2.66aa9a7b.gif";